import {
  CARD_NUMBER_REGXP,
  ZIP_CODE_REGXP,
} from '../../../constants/patterns';

import luhnAlgorithm from '../../validators/luhn-algorithm';

export default function payoutCardPreSubmit(formData) {
  if (!formData) {
    return [];
  }

  const errors = [];

  if (!formData.paymentOption &&
      (!CARD_NUMBER_REGXP.test(formData.cardNumber) || !luhnAlgorithm(formData.cardNumber))
    ) {
    errors.push({
      field: 'cardNumber',
      // https://contegixapp1.livenation.com/confluence/display/LT/Payment+Options+API#PaymentOptionsAPI-error_codes
      errorKey: 'payment.errors.INVALID_CARD_NUMBER',
      currentValue: formData.cardNumber,
    });
  }

  if (formData.zipCode && formData.zipCode.length < 5 || !ZIP_CODE_REGXP.test(formData.zipCode)) {
    errors.push({
      field: 'zipCode',
      // https://contegixapp1.livenation.com/confluence/display/LT/Payment+Options+API#PaymentOptionsAPI-error_codes
      errorKey: 'payment.errors.INVALID_POSTAL_CODE',
      currentValue: formData.zipCode,
    });
  }

  if (formData.expirationYear === 'YY') {
    errors.push({
      field: 'expirationYear',
      // https://contegixapp1.livenation.com/confluence/display/LT/Payment+Options+API#PaymentOptionsAPI-error_codes
      errorKey: 'payment.errors.INVALID_CARD_EXPIRATION_YEAR',
      currentValue: formData.expirationYear,
    });
  }

  if (formData.expirationMonth === 'MM') {
    errors.push({
      field: 'expirationMonth',
      // https://contegixapp1.livenation.com/confluence/display/LT/Payment+Options+API#PaymentOptionsAPI-error_codes
      errorKey: 'payment.errors.INVALID_CARD_EXPIRATION_MONTH',
      currentValue: formData.expirationMonth,
    });
  }

  return errors;
}
